import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@/.sourceflow/awards_industry_recognition.json";

export const useAwards = ({ limit } = {}) => {
  const collection = useSourceFlowCollection(data);

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useAwards;
